import { $http } from '@/utils';
const _iotCenter = true ? '/iot-center' : '';

/**
 * 参数配置
 *
*/

// eslint-disable-next-line import/no-anonymous-default-export
export default {

    //终端参数-重启
    restartTerminal(data) {
        return $http.post(_iotCenter + '/param/afn01/f001/write', data);
    },

    //终端参数-版本信息
    getTerminalVersion(data) {
        return $http.get(_iotCenter + '/param/afn09/f001/data', data);
    },

    //终端参数-版本信息-召测终端版本信息
    readTerminalVersion(data) {
        return $http.post(_iotCenter + '/param/afn09/f001/read', data);
    },

    //终端参数-实时数据-连接状态
    getTerminalLinkStatus(data) {
        return $http.get(_iotCenter + '/query/device/online', data);
    },


    //终端参数-获取主站IP地址和端口信息
    getTerminalPortInfo(data) {
        return $http.get(_iotCenter + '/param/afn0a/f003/data', data);
    },

    //终端参数-版本信息-召测终端 端口信息
    readTerminalPortInfo(data) {
        return $http.post(_iotCenter + '/param/afn0a/f003/read', data);
    },

    //终端参数-版本信息-设置主站IP地址和端口信息
    writeTerminalPortInfo(data) {
        return $http.post(_iotCenter + '/param/afn0a/f003/write', data);
    },


    //电表配置 - 获取电表数据
    getMeterData(data) {
        return $http.get(_iotCenter + '/param/afn0a/f010/data', data);
    },

    //电表配置 - 获取电表数据
    clearTerminalFile(data) {
        return $http.delete(_iotCenter + '/param/afn04/f010/data',{}, data);
    },

    //电表配置 - 批量档案下发
    downCheckboxMeter(data) {
        return $http.post(_iotCenter + '/param/afn04/f010/write', data);
    },

    //电表配置 - 批量档案召测
    readCheckboxMeter(data) {
        return $http.post(_iotCenter + '/param/afn0a/f010/write', data);
    },

    //电表-送电断电
    meterBreakcontrol(data) {
        return $http.post(_iotCenter + '/param/afn10/f001/breakcontrol', data);
    },


    //任务列表数据
    getTaskData(data) {
        return $http.get(_iotCenter + '/task/device/table', data);
    },

    //设备任务读取
    readTaskData(data) {
        return $http.post(_iotCenter + '/task/device/release/read', data);
    },

    //设备任务状态读取
    readTaskStatusData(data) {
        return $http.post(_iotCenter + '/task/device/state/read', data);
    },

    //设备启用禁用操作
    handleEnableDisable(data) {
        return $http.post(_iotCenter + '/task/device/state', data);
    },

    //设备任务下发
    handleTaskDown(data) {
        return $http.post(_iotCenter + '/task/device/release', data);
    },
    //再次下发
    handleAgainTaskDown(equipmentId){
        return $http.post(_iotCenter + '/afn10/reTrySendMqMeterCfgTimeInterval/'+equipmentId);
    },

    //时段定义数据显示
    getTimeData(deviceId) {
        return $http.get(_iotCenter + `/period/device/${deviceId}/table`);
    },


    // //设备时段下发
    // writeTimeOption(deviceId) {
    //     return $http.post(_iotCenter + `/period/device/${deviceId}/release`);
    // },
    //
    // //设备时段读取
    // readTimeOption(deviceId) {
    //     return $http.post(_iotCenter + `/period/device/${deviceId}/release/read`);
    // },
    //时段下发
    writeTimeToOption(data) {
        return $http.post(_iotCenter + `/afn10/configTimeIntervalRate2`,data);
    },
    //获取时段信息
    getDeviceTimeInfoList(data){
        return $http.get(_iotCenter + `/afn10/configTimeIntervalRateRead2/list`,data);
    },
    //时段信息召测
    readTimeInfo(data){
        return $http.post(_iotCenter + `/afn10/configTimeIntervalRateRead2`,data);
    },
    //获取流控命令列表
    getCommandList(data){
        return $http.get(_iotCenter + `/query/device/${data.id}/command`,data);
    }
}
